<template>
    <div class="login_b">
        <div class="login_left"></div>
        <div class="login_buttom">
            <div class="login_name">
                <div class="login_name_welcome">欢迎使用</div>
                <div class="login_name_system">婧贤后台管理系统</div>

            </div>
            <div class="input_box"  @keyup.enter="login('ruleForm')">
                <el-form :model="input" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                    <el-form-item  prop="number">
                        <el-input style="width: 365px;" v-model="input.number" placeholder="请输入手机号码"></el-input>
                        <img class="icon_img" src="../../../assets/icons/user.png" alt="">
                    </el-form-item>
                    <el-form-item  prop="password">
                        <el-input v-model="input.password"  show-password placeholder="请输入密码"></el-input>
                        <img class="icon_img" src="../../../assets/icons/password.png" alt="">
                    </el-form-item>
                    <el-form-item >
                        
                        <el-button style="width: 100%;background: #2882FE;color: #fff;" @click="login('ruleForm')">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import {sortHeaders, stringToHex1 } from '@/utils/HeaderKey'

    export default{
        data(){
            return{
                img:'https://img1.baidu.com/it/u=4049022245,514596079&fm=253&fmt=auto&app=120&f=JPEG?w=889&h=500',
                input:{
                    number:'',
                    password:''
                },
                rules: {
                    number: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                },
            }
        },
        methods:{ 
            login(formName){
                sessionStorage.clear()
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let obj={
                            account:this.input.number,
                            password:this.input.password
                        }
                        this.$http.post('v1/login',obj).then((res)=>{
                            if(res.code==200){
                                let tokensss = stringToHex1(res.data.token)
                                sessionStorage.setItem('user_token',tokensss)
                                sessionStorage.setItem('user',JSON.stringify( res.data.userInfo))
                                this.$router.push('/home')
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:'error'
                                })
                            }
                        })
                        
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/.el-input__inner{
    text-indent:20px
}
/deep/.el-input__inner::placeholder {

    position:relative;
    
}
/deep/.el-form-item{
    position: relative;    
    .icon_img{
        position: absolute;
        top: 10px;
        width: 18px;
        height: 18px;
        left: 10px;

    }
}
    .login_b{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        .login_left{
            width: 60%;
            height: 100%;
            background-image: url(../../../assets/loginleft.png) ;
            background-repeat: no-repeat;
        }
        .login_buttom{
            width: 30%;
            height: 100%;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .login_name{
                margin-left: 106px;
                .login_name_welcome{
                    font-size: 28px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 42px;
                }
                .login_name_system{
                    font-size: 36px;
                    font-weight: 500;
                    color: #2882FE;
                    line-height: 42px;
                }
            }
        }
        .input_box{
            margin-top: 72px;
            margin-left: 106px;
            
        }
    }
</style>